/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://xb7tpd22u5fpnoul7nru4s4hie.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-yrxzlruxt5amdgfa6xehh43gle",
    "aws_cloud_logic_custom": [
        {
            "name": "webhooksApi",
            "endpoint": "https://ehodh6sq9f.execute-api.eu-west-1.amazonaws.com/develop",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:3f06ad51-475b-4dd2-a7c1-64e021a94809",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_UZirYQfEe",
    "aws_user_pools_web_client_id": "50vjm7ik0rio5kensvtk7vcu90",
    "oauth": {}
};


export default awsmobile;
